import { css } from "styled-components";
import token from "styled-token";
import { StyledImage } from "../../components/Image/Image";
import { StyledPropertyCardPhotoFallback } from "../../components/PropertyCard/PropertyCardPhotoFallback";
import { PROPERTY_CARD_APPEARANCES } from "../../constants/PROPERTY_CARD";
import { PHOTO_ORIENTATIONS } from "../../constants/ORIENTATIONS";

var fallbackImageCSS = function fallbackImageCSS(props) {
  var appearance = props.appearance;
  return token({
    fill: "PropertyCard.fallbackImage.fill",
    size: "PropertyCard.fallbackImage.size." + appearance
  }, function (_ref) {
    var fill = _ref.fill,
        size = _ref.size;
    return css(["", "{height:", "px;width:", "px;.Fallback__fill{fill:", ";}}"], StyledPropertyCardPhotoFallback, size, size, fill);
  })(props);
};

var portraitBackgroundCSS = function portraitBackgroundCSS(props) {
  var photoOrientation = props.photoOrientation,
      photoSrc = props.photoSrc;

  if (photoOrientation !== PHOTO_ORIENTATIONS.PORTRAIT) {
    return "";
  }
  /* To help portrait photos fill up their container, add a
  blurred version in the background. */


  return css(["&:after{background:url(", ") no-repeat #f6f6fa;background-size:cover;content:\"\";display:block;filter:blur(8px);position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;}"], photoSrc);
};
/** @class PropertyCardPhotoMixin */

/** @method */


export var PropertyCardPhotoMixin = function PropertyCardPhotoMixin(props) {
  return token({
    backgroundColor: "PropertyCard.photo.backgroundColor",
    borderRadius: "PropertyCard.cardBody.borderRadius"
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        borderRadius = _ref2.borderRadius;
    var isPhotoLandscape = props.photoOrientation === PHOTO_ORIENTATIONS.LANDSCAPE;
    var isVerticalCard = props.appearance === PROPERTY_CARD_APPEARANCES.LARGE || props.appearance === PROPERTY_CARD_APPEARANCES.SMALL;
    return css(["border-top-left-radius:", "px;border-top-right-radius:", "px;border-bottom-right-radius:0;border-bottom-left-radius:", "px;height:100%;overflow:hidden;position:relative;z-index:0;background-color:", ";", ",", "{position:absolute;left:50%;top:50%;transform:translate3d(-50%,-50%,0);}", "{max-height:", ";max-width:", ";width:", ";height:", ";}", " ", ""], borderRadius, isVerticalCard ? borderRadius : 0, isVerticalCard ? 0 : borderRadius, backgroundColor, StyledImage, StyledPropertyCardPhotoFallback, StyledImage, isPhotoLandscape ? "none" : "100%", isPhotoLandscape ? "100%" : "none", isPhotoLandscape ? "100%" : "auto", isPhotoLandscape ? "auto" : "100%", fallbackImageCSS(props), portraitBackgroundCSS(props));
  })(props);
};